import React, { useState } from 'react';
import type { UploadFile } from 'antd/es/upload/interface';

import {
  trackUploadShotReminderAccept,
  trackUploadShotReminderReject,
} from '../../../analytics';

import { Spinner, Button, Modal, Checkbox } from '../../../components/general';

import { updateUser } from '../../../services/api/auth';

import { useProjectStore } from '../../../stores/project';
import { useUserStore } from '../../../stores/user';

import { VideoMode } from '../../../types';
import { getShotImage } from '../../../utils';

interface Props {
  show: boolean;
  onHide: () => void;
  mode?: VideoMode;
  handleUpload: (files?: UploadFile[]) => void;
  rejectUpload: () => void;
}

const ShotModal: React.FC<Props> = (props) => {
  const { show, onHide, mode, handleUpload, rejectUpload } = props;

  const { user, setUser } = useUserStore();
  const { updateCurrentEvent } = useProjectStore();

  const [isSaved, setIsSaved] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateEvent = async () => {
    if (mode) return;

    setIsUpdating(true);
    await updateCurrentEvent();
    setIsUpdating(false);
  };

  // accept upload & hide modal
  const handleAccept = async () => {
    await handleUpdateEvent();

    handleUpload();
    onHide();

    // store in database that reminder is saved (won't show again)
    if (user && isSaved) {
      const userData = await updateUser(user.userId, {
        dismissedShotReminder: true,
      });
      setUser({ ...userData.user, session: user.session });
    }

    trackUploadShotReminderAccept(isSaved);
  };

  // reject upload & hide modal
  const handleReject = async () => {
    await handleUpdateEvent();

    rejectUpload();
    onHide();

    trackUploadShotReminderReject();
  };

  return (
    <Modal show={show} onHide={handleReject} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Reminder</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          Please ensure you have added the "SHOT" wildcards slots to the
          highlight reel before uploading.
        </div>

        <img
          className="max-w-full max-h-80 self-center rounded-md border border-black border-solid"
          src={getShotImage(mode ?? 'landscape')}
          alt="Shot Placeholder"
        />

        <Checkbox
          id="shot-checkbox"
          label="Don't show again"
          name="isShotModalSaved"
          checked={isSaved}
          onChange={(e) => setIsSaved(e.target.checked)}
        />

        {isUpdating ? (
          <div className="w-full h-[var(--form-el-height)] flex items-center justify-center">
            <Spinner size="lg" />
          </div>
        ) : (
          <div className="flex flex-col sm:flex-row gap-4">
            <Button className="w-full sm:w-1/2" onClick={handleAccept}>
              I Have "SHOT" Included
            </Button>

            <Button
              colour="pink"
              className="w-full sm:w-1/2"
              onClick={handleReject}
            >
              Cancel Upload
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ShotModal;
